import React, { useState, useEffect } from "react";
import axios from "axios";
import '../styles/BlogDetail.css';
import { useParams } from 'react-router-dom';
import dateFormat from 'dateformat';
import Subscribe from "./Subscribe";
import { Box, Typography } from "@mui/material";
import Divider from '@mui/material/Divider';


// const BlogDetail = () => {
//     const { id } = useParams(); // Get the blog ID from the URL
//     const [blog, setBlog] = useState(null);

//     // Fetch single blog details
//     const getBlogDetails = async () => {
//         try {
//             const { data } = await axios.get(`/api/v1/blog/get-blog/${id}`);
//             if (data?.success) {
//                 setBlog(data?.blog);
//             }
//         } catch (error) {
//             console.error("Error fetching blog details:", error);
//         }
//     };

//     useEffect(() => {
//         getBlogDetails();
//     }, [id]);

//     if (!blog) {
//         return <p>Loading blog details...</p>;
//     }
//     return (
//         <div className="my-container">
//             <h1 className="heading">{blog.title}</h1><br />
//             {/* <h3 className="desciption">{blog.description}</h3> */}
//             <p className="date">
//                 <strong>Published on : </strong>
//                 {dateFormat(blog.createdAt, "mmmm dS, yyyy HH:MM:ss")}
//             </p><br></br>
//             <div className="content">
//                 <div
//                     dangerouslySetInnerHTML={{
//                         __html: blog.content
//                     }}
//                 />
//             </div>
//             <Box
//                 sx={{ textAlign: "center", my: 3, }}
//             >
//                 <Typography variant="h5" sx={{ color: '#1A1A19' }}>
//                     <Divider>Subscribe to never miss a new upload!</Divider>
//                 </Typography>
//                 <Subscribe />
//             </Box>

//         </div>
//     );
// };

// export default BlogDetail;

const BlogDetail = () => {
    // const { id } = useParams();
    const { blogUrl } = useParams();
    const [blog, setBlog] = useState(null);
    const id = blogUrl.substring(blogUrl.lastIndexOf("-") + 1);

    const getBlogDetails = async () => {
        try {
            const { data } = await axios.get(`/api/v1/blog/get-blog/${id}`);
            if (data?.success) {
                setBlog(data.blog);
            }
        } catch (error) {
            console.error("Error fetching blog details:", error);
        }
    };

    useEffect(() => {
        getBlogDetails();
    }, [id]);

    useEffect(() => {
        if (!blog) return;

        // Title
        document.title = `${blog.title} | Practical Pet Parenting`;

        // Meta Description
        let metaDescription = document.querySelector(
            'meta[name="description"]'
        );

        if (!metaDescription) {
            metaDescription = document.createElement("meta");
            metaDescription.setAttribute("name", "description");
            document.head.appendChild(metaDescription);
        }

        metaDescription.setAttribute(
            "content",
            blog.description || "Practical Pet Parenting"
        );

        // Canonical URL
        let canonical = document.querySelector(
            "link[rel='canonical']"
        );

        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }

        canonical.href = window.location.href;

    }, [blog]);
    
    if (!blog) {
        return (
            <div className="loading-container">
                <p className="loading-text">Loading blog details...</p>
            </div>
        );
    }

    return (
        <div className="my-container blog-detail-container">
            <h1 className="blog-title">{blog.title}</h1>

            <p className="blog-date">
                <strong>Published on:</strong>{" "}
                {dateFormat(blog.createdAt, "mmmm dS, yyyy HH:MM:ss")}
            </p>

            <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: blog.content }}
            />

            <Box sx={{ textAlign: "center", my: 6 }}>
                <Typography variant="h5" sx={{ color: "#1A1A19", mb: 2 }}>
                    <Divider>Subscribe to never miss a new upload!</Divider>
                </Typography>
                <Subscribe />
            </Box>
        </div>
    );
};

export default BlogDetail;